// Locale JSONs are imported via Vite's ?url suffix so each ends up as a
// hashed asset in the build, which the PWA precache then picks up.
import enUrl from './locales/en.json?url';
import jaUrl from './locales/ja.json?url';

export type Locale = 'en' | 'ja';
type Translations = Record<string, string>;

const localeUrls: Record<Locale, string> = { en: enUrl, ja: jaUrl };

let current: Locale = 'en';
let messages: Translations = {};
const listeners: Array<() => void> = [];

export async function loadLocale(locale: Locale): Promise<void> {
  const response = await fetch(localeUrls[locale]);
  messages = (await response.json()) as Translations;
  current = locale;
  localStorage.setItem('demo.locale', locale);
  listeners.forEach((fn) => fn());
}

export async function init(): Promise<void> {
  const stored = localStorage.getItem('demo.locale') as Locale | null;
  const browser: Locale = navigator.language.startsWith('ja') ? 'ja' : 'en';
  await loadLocale(stored ?? browser);
}

export function t(key: string, params: Record<string, string | number> = {}): string {
  const tpl = messages[key] ?? key;
  return tpl.replace(/\{(\w+)\}/g, (_, k: string) => {
    const v = params[k];
    return v === undefined ? `{${k}}` : String(v);
  });
}

export function currentLocale(): Locale {
  return current;
}

export function onLocaleChange(fn: () => void): void {
  listeners.push(fn);
}
